module.exports = __webpack_public_path__ + "static/media/rled6-cn.5e9eca3e.jpg";